import { RouteObject } from 'react-router-dom';
import { MaintenanceGuard } from '../MaintenanceGuard';
import FunctionaryLayout from '../components/layout/FunctionaryLayout';
import { PredefinedReasonsProvider } from '../hooks/usePredefinedReasons';
import {
	FUNCTIONARY_HOME,
	BATCH_HOME,
	SCREENING_DASHBOARD,
	SCREENING_CREATE_BATCH,
	SCREENING_EDIT_BATCH,
	SCREENING_ELIGIBLE_CANDIDATES,
	SCREENING_VIEW_BATCH,
	PROPOSER_REASSIGN,
	CENTRAL_TEAM_DASHBOARD,
	CENTRAL_TEAM_APPLICATIONS,
	PRE_WORK_APPLICATIONS,
	SELECT_MODULE,
	COMING_SOON,
	ANSWERS_REVIEW,
	ANSWERS_REVIEW_CONTEXT,
	APPLICANT_CONTEXT,
	APPLICANT_INTERVIEW,
	VIEW_APPLICANT_INTERVIEW,
	PRECEPTOR_CONTEXT,
	PRECEPTOR_INTERVIEW,
	VIEW_PRECEPTOR_INTERVIEW,
	FAMILY_CONTEXT,
	FAMILY_MEMBER_INTERVIEW,
	VIEW_FAMILY_MEMBER_INTERVIEW,
	OTHER_REFERENCE_CONTEXT,
	OTHER_REFERENCE_INTERVIEW,
	VIEW_OTHER_REFERENCE_INTERVIEW,
	PROPOSER_RECOMMENDATION,
	CARE_TEAM_RECOMMENDATION,
	ZC_RECOMMENDATION,
	APPROVER_RECOMMENDATION,
	INTERVIEW_LANDING,
	APPLICANT_ADDITIONAL_DETAILS,
	SKIP_ALL_INTERVIEWS,
	VIEW_ANSWERS,
	VIEW_FUNCTIONARIES,
	ADD_FUNCTIONARY,
	EDIT_FUNCTIONARY,
	VIEW_QUESTIONS_ANSWERS,
	PRE_WORK_INTERVIEW,
	PRE_WORK_MENTOR_CONTEXT,
	VIEW_CARE_TEAM_APPLICANT_ANSWERS,
	VIEW_CARE_TEAM_APPLICANT_INTERVIEW_ANSWERS,
	VIEW_CARE_TEAM_FAMILY_ANSWERS,
	PROPOSER_LOAD_DASHBOARD,
	PROPOSER_LOAD_REASSIGN,
	PROPOSER_LOAD_VIEW,
	PROPOSER_LOAD_ZONES,
	MANAGE_PRIVILEGES,
	MODULES_LIST,
	SELF_REGISTER,
} from '../shared/Routes';

// Import all required pages
import { FunctionaryHome } from '../pages/functionary/Home';
import { ScreeningDashboard } from '../pages/functionary/DashboardPage';
import { ProposerReassign } from '../pages/functionary/DashboardPage/ProposerReassign';
import { CentralTeamDashboard } from '../pages/functionary/CentralTeamDashboardPage';
import { CentralTeamApplicationsList } from '../pages/functionary/CentralTeamApplicationsList';
import { BatchListContainer } from '../pages/functionary/BatchList';
import { ScreeningCreateBatch } from '../pages/functionary/BatchList/CreateOrViewOrEditBatch';
import { ScreeningEligibleCandidates } from '../pages/functionary/BatchList/EligibleCandidates';
import { ApplicantAnswersReviewWizardContainer } from '../pages/functionary/ApplicantAnswersReviewWizard';
import { AnswersReviewContextWizardContainer } from '../pages/functionary/ApplicantAnswersReviewWizard/AnswersReviewContext';
import { ApplicantContextWizardContainer } from '../pages/functionary/ApplicantInterviewWizard/ApplicantContextPolicy';
import { ApplicantInterviewWizardContainer } from '../pages/functionary/ApplicantInterviewWizard';
import { PreceptorContextWizardContainer } from '../pages/functionary/PreceptorInterviewWizard/PreceptorContextPolicy';
import { PreceptorInterviewWizardContainer } from '../pages/functionary/PreceptorInterviewWizard';
import { FamilyMemberContextWizardContainer } from '../pages/functionary/FamilyMemberInterviewWizard/FamilyContextPolicy';
import { FamilyMemberInterviewWizardContainer } from '../pages/functionary/FamilyMemberInterviewWizard';
import { OtherReferenceProposerRecommendationPage } from '../pages/functionary/OtherReferenceInterviewWizard';
import { OtherReferenceInterviewWizardContainer } from '../pages/functionary/OtherReferenceInterviewWizard/Stepsindex';
import { ProposerRecommendationCollectionPageContainer } from '../pages/functionary/ProposerRecommendationPage';
import { CareTeamRecommendationCollectionPageContainer } from '../pages/functionary/CareTeamRecommendationPage';
import { ZCRecommendationCollectionPageContainer } from '../pages/functionary/ZCRecommendationPage';
import { ApproverRecommendationCollectionPageContainer } from '../pages/functionary/ApproverRecommendationPage';
import { LandingPageContainer } from '../pages/functionary/InterviewLandingPage';
import { ApplicantAdditionalCollectionPageContainer } from '../pages/functionary/ApplicantAdditionalDetailsPage';
import { SkipAllInterviewsCollectionPageContainer } from '../pages/functionary/SkipAllInterviewsPage';
import { ViewApplicantAnswersWizardContainer } from '../pages/functionary/ViewApplicantAnswersWizard';
import { FunctionariesListContainer } from '../pages/functionary/FunctionariesList';
import { AddOrEditFunctionaryPageContainer } from '../pages/functionary/AddOrEditFunctionaryPage';
import { ViewQuestionsAndAnswers } from '../pages/functionary/ViewQuestionsAndAnswers';
import { PreworkMentorContextPage } from '../pages/functionary/PreworkMentorContextPage';
import { PreWorkInterviewWizardContainer } from '../pages/functionary/PreWorkInterviewWizard';
import { PreworkMentorApplicationsListContainer } from '../pages/functionary/PreworkMentorApplicationsList';
import { ViewCareTeamApplicantAnswersWizardContainer } from '../pages/functionary/ViewCareTeamApplicantAnswersWizard';
import { ViewCareTeamApplicantInterviewAnswersWizardContainer } from '../pages/functionary/ViewCareTeamApplicantInterviewAnswersWizard';
import { ViewCareTeamFamilyMemberInterviewAnswersWizardContainer } from '../pages/functionary/ViewCareTeamFamilyMemberInterviewAnswersWizard';
import { SelectModule } from '../pages/login/SelectModule';
import { ComingSoon } from '../pages/functionary/ComingSoon';
import { ProposerLoadDashboard } from '../pages/functionary/ProposerLoadDashboard';
import { ProposerReAssign } from '../pages/functionary/ProposerLoadDashboard/ProposerReAssign';
import { ViewProposerLoad } from '../pages/functionary/ProposerLoadDashboard/ViewProposerLoad';
import { ZonesProposerLoad } from '../pages/functionary/ProposerLoadDashboard/ZonesProposerLoad';
import { ManagePrivileges } from '../pages/functionary/ManagePrivileges';
import { RolesWithModulesList } from '../pages/functionary/RolesWithModulesList';
import { SelfRegistration } from '../pages/functionary/SelfRegistration';

export const FunctionaryRoutes: RouteObject[] = [
	{
		element: (
			<MaintenanceGuard
				component={
					<PredefinedReasonsProvider>
						<FunctionaryLayout />
					</PredefinedReasonsProvider>
				}
			/>
		),
		children: [
			{
				path: FUNCTIONARY_HOME,
				element: <MaintenanceGuard component={<FunctionaryHome />} />,
			},
			{
				path: BATCH_HOME,
				element: <MaintenanceGuard component={<BatchListContainer />} />,
			},
			{
				path: SCREENING_DASHBOARD,
				element: <MaintenanceGuard component={<ScreeningDashboard />} />,
			},
			{
				path: SCREENING_CREATE_BATCH,
				element: <MaintenanceGuard component={<ScreeningCreateBatch />} />,
			},
			{
				path: SCREENING_EDIT_BATCH,
				element: <MaintenanceGuard component={<ScreeningCreateBatch />} />,
			},
			{
				path: SCREENING_ELIGIBLE_CANDIDATES,
				element: (
					<MaintenanceGuard component={<ScreeningEligibleCandidates />} />
				),
			},
			{
				path: SCREENING_VIEW_BATCH,
				element: <MaintenanceGuard component={<ScreeningCreateBatch />} />,
			},
			{
				path: PROPOSER_REASSIGN,
				element: <MaintenanceGuard component={<ProposerReassign />} />,
			},
			{
				path: CENTRAL_TEAM_DASHBOARD,
				element: <MaintenanceGuard component={<CentralTeamDashboard />} />,
			},
			{
				path: PROPOSER_LOAD_DASHBOARD,
				element: <MaintenanceGuard component={<ProposerLoadDashboard />} />,
			},
			{
				path: PROPOSER_LOAD_REASSIGN,
				element: <MaintenanceGuard component={<ProposerReAssign />} />,
			},
			{
				path: PROPOSER_LOAD_VIEW,
				element: <MaintenanceGuard component={<ViewProposerLoad />} />,
			},
			{
				path: PROPOSER_LOAD_ZONES,
				element: <MaintenanceGuard component={<ZonesProposerLoad />} />,
			},
			{
				path: CENTRAL_TEAM_APPLICATIONS,
				element: (
					<MaintenanceGuard component={<CentralTeamApplicationsList />} />
				),
			},
			{
				path: PRE_WORK_APPLICATIONS,
				element: (
					<MaintenanceGuard
						component={<PreworkMentorApplicationsListContainer />}
					/>
				),
			},
			{
				path: SELECT_MODULE,
				element: <MaintenanceGuard component={<SelectModule />} />,
			},
			{
				path: COMING_SOON,
				element: <MaintenanceGuard component={<ComingSoon />} />,
			},
			{
				path: ANSWERS_REVIEW,
				element: (
					<MaintenanceGuard
						component={<ApplicantAnswersReviewWizardContainer />}
					/>
				),
			},
			{
				path: ANSWERS_REVIEW_CONTEXT,
				element: (
					<MaintenanceGuard
						component={<AnswersReviewContextWizardContainer />}
					/>
				),
			},
			{
				path: APPLICANT_CONTEXT,
				element: (
					<MaintenanceGuard component={<ApplicantContextWizardContainer />} />
				),
			},
			{
				path: APPLICANT_INTERVIEW,
				element: (
					<MaintenanceGuard component={<ApplicantInterviewWizardContainer />} />
				),
			},
			{
				path: VIEW_APPLICANT_INTERVIEW,
				element: (
					<MaintenanceGuard component={<ApplicantInterviewWizardContainer />} />
				),
			},
			{
				path: PRECEPTOR_CONTEXT,
				element: (
					<MaintenanceGuard component={<PreceptorContextWizardContainer />} />
				),
			},
			{
				path: PRECEPTOR_INTERVIEW,
				element: (
					<MaintenanceGuard component={<PreceptorInterviewWizardContainer />} />
				),
			},
			{
				path: VIEW_PRECEPTOR_INTERVIEW,
				element: (
					<MaintenanceGuard component={<PreceptorInterviewWizardContainer />} />
				),
			},
			{
				path: FAMILY_CONTEXT,
				element: (
					<MaintenanceGuard
						component={<FamilyMemberContextWizardContainer />}
					/>
				),
			},
			{
				path: FAMILY_MEMBER_INTERVIEW,
				element: (
					<MaintenanceGuard
						component={<FamilyMemberInterviewWizardContainer />}
					/>
				),
			},
			{
				path: VIEW_FAMILY_MEMBER_INTERVIEW,
				element: (
					<MaintenanceGuard
						component={<FamilyMemberInterviewWizardContainer />}
					/>
				),
			},
			{
				path: OTHER_REFERENCE_CONTEXT,
				element: (
					<MaintenanceGuard
						component={<OtherReferenceProposerRecommendationPage />}
					/>
				),
			},
			{
				path: OTHER_REFERENCE_INTERVIEW,
				element: (
					<MaintenanceGuard
						component={<OtherReferenceInterviewWizardContainer />}
					/>
				),
			},
			{
				path: VIEW_OTHER_REFERENCE_INTERVIEW,
				element: (
					<MaintenanceGuard
						component={<OtherReferenceProposerRecommendationPage />}
					/>
				),
			},
			{
				path: PROPOSER_RECOMMENDATION,
				element: (
					<MaintenanceGuard
						component={<ProposerRecommendationCollectionPageContainer />}
					/>
				),
			},
			{
				path: CARE_TEAM_RECOMMENDATION,
				element: (
					<MaintenanceGuard
						component={<CareTeamRecommendationCollectionPageContainer />}
					/>
				),
			},
			{
				path: ZC_RECOMMENDATION,
				element: (
					<MaintenanceGuard
						component={<ZCRecommendationCollectionPageContainer />}
					/>
				),
			},
			{
				path: APPROVER_RECOMMENDATION,
				element: (
					<MaintenanceGuard
						component={<ApproverRecommendationCollectionPageContainer />}
					/>
				),
			},
			{
				path: INTERVIEW_LANDING,
				element: <MaintenanceGuard component={<LandingPageContainer />} />,
			},
			{
				path: APPLICANT_ADDITIONAL_DETAILS,
				element: (
					<MaintenanceGuard
						component={<ApplicantAdditionalCollectionPageContainer />}
					/>
				),
			},
			{
				path: SKIP_ALL_INTERVIEWS,
				element: (
					<MaintenanceGuard
						component={<SkipAllInterviewsCollectionPageContainer />}
					/>
				),
			},
			{
				path: VIEW_ANSWERS,
				element: (
					<MaintenanceGuard
						component={<ViewApplicantAnswersWizardContainer />}
					/>
				),
			},
			{
				path: VIEW_FUNCTIONARIES,
				element: (
					<MaintenanceGuard component={<FunctionariesListContainer />} />
				),
			},
			{
				path: ADD_FUNCTIONARY,
				element: (
					<MaintenanceGuard component={<AddOrEditFunctionaryPageContainer />} />
				),
			},
			{
				path: EDIT_FUNCTIONARY,
				element: (
					<MaintenanceGuard component={<AddOrEditFunctionaryPageContainer />} />
				),
			},
			{
				path: VIEW_QUESTIONS_ANSWERS,
				element: <MaintenanceGuard component={<ViewQuestionsAndAnswers />} />,
			},
			{
				path: PRE_WORK_INTERVIEW,
				element: (
					<MaintenanceGuard component={<PreWorkInterviewWizardContainer />} />
				),
			},
			{
				path: PRE_WORK_MENTOR_CONTEXT,
				element: <MaintenanceGuard component={<PreworkMentorContextPage />} />,
			},
			{
				path: VIEW_CARE_TEAM_APPLICANT_ANSWERS,
				element: (
					<MaintenanceGuard
						component={<ViewCareTeamApplicantAnswersWizardContainer />}
					/>
				),
			},
			{
				path: VIEW_CARE_TEAM_APPLICANT_INTERVIEW_ANSWERS,
				element: (
					<MaintenanceGuard
						component={<ViewCareTeamApplicantInterviewAnswersWizardContainer />}
					/>
				),
			},
			{
				path: VIEW_CARE_TEAM_FAMILY_ANSWERS,
				element: (
					<MaintenanceGuard
						component={
							<ViewCareTeamFamilyMemberInterviewAnswersWizardContainer />
						}
					/>
				),
			},
			{
				path: MODULES_LIST,
				element: <MaintenanceGuard component={<RolesWithModulesList />} />,
			},
			{
				path: MANAGE_PRIVILEGES,
				element: <MaintenanceGuard component={<ManagePrivileges />} />,
			},
			{
				path: SELF_REGISTER,
				element: <MaintenanceGuard component={<SelfRegistration />} />,
			},
		],
	},
];
